import SkillCard, { SkillCardProps } from './SkillCard';
import './SkillCategorySection.css';

export interface SkillCategorySectionProps {
  title: string;
  description: string;
  gradient: 'green' | 'yellow' | 'blue' | 'purple';
  skills: SkillCardProps[];
  onToggle?: (skillName: string, agentName: string, equip: boolean) => Promise<void>;
}

export default function SkillCategorySection({
  title,
  description,
  gradient,
  skills,
  onToggle,
}: SkillCategorySectionProps) {
  return (
    <section className="skill-category">
      <div className={`skill-category__banner skill-category__banner--${gradient}`}>
        <div className="skill-category__grid">
          <div className="skill-category__info">
            <h2 className="skill-category__title">{title}</h2>
            <p className="skill-category__desc">{description}</p>
          </div>
          {skills.map((skill, i) => (
            <SkillCard key={`${skill.skillName || skill.title}-${i}`} {...skill} onToggle={onToggle} />
          ))}
        </div>
      </div>
    </section>
  );
}
